import colors from 'config/theme/colors';
import transitions from 'config/theme/transitions';

/**
 * @version 1.0
 * @param {object} SIZES define the button sizes from design
 * @param {object} STYLES define the button styles from design
 * @param {object} THEMES define the button themes from design
 * @note Colors and Transitions is also to be modified to the design needs.
 */

export const SIZES = {
    xs: {
        padding: '4px 12px',
    },
    sm: {
        padding: '8px 16px',
    },
    md: {
        padding: '12px 24px',
    },
    lg: {
        padding: '12px 40px',
    },
    xl: {
        padding: '16px 40px',
    },
};

export const STYLES = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: '100px',
    textDecoration: 'none',
    userSelect: 'none',
    outline: 'none',
    transition: `all ${transitions.primary}`,
};

export const THEMES = {
    black: {
        color: colors.white,
        backgroundColor: colors.black,
        borderColor: colors.black,
        borderWidth: '1px',
        borderStyle: 'solid',
        hover: {
            color: colors.white,
            borderColor: colors.black,
            backgroundColor: colors.black,
        },
        disabled: {
            opacity: '50%',
        },
    },
    green: {
        color: colors.white,
        backgroundColor: colors.green,
        border: 'none',
        hover: {
            color: colors.white,
            backgroundColor: colors.green,
        },
        disabled: {
            color: colors.white,
            backgroundColor: colors.blackOpacityLow,
        },
    },
    outlinedBlack: {
        color: colors.black,
        backgroundColor: 'transparent',
        borderColor: colors.black,
        borderWidth: '1px',
        borderStyle: 'solid',
        hover: {
            color: colors.white,
            backgroundColor: colors.black,
            borderColor: colors.black,
        },
        disabled: {
            opacity: '50%',
        },
    },
    outlinedWhite: {
        color: colors.white,
        backgroundColor: 'transparent',
        borderColor: colors.white,
        borderWidth: '1px',
        borderStyle: 'solid',
        hover: {
            color: colors.black,
            backgroundColor: colors.white,
            borderColor: colors.white,
        },
        disabled: {
            opacity: '50%',
        },
    },
    blurWhite: {
        color: colors.black,
        backgroundColor: colors.whiteOpacityHigh,
        borderColor: colors.grey4,
        borderWidth: '1px',
        borderStyle: 'solid',
        boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.04)',
        backdropFilter: 'blur(16px)',
        hover: {
            color: colors.black,
            backgroundColor: colors.whiteOpacityHigh,
            borderColor: colors.grey4,
        },
        disabled: {
            opacity: '50%',
        },
    },
    error: {
        color: colors.white,
        backgroundColor: colors.error,
        borderColor: colors.error,
        borderWidth: '1px',
        borderStyle: 'solid',
    },
};
